import { render, staticRenderFns } from "./IconOrderBy.vue?vue&type=template&id=0042759c"
import script from "./IconOrderBy.vue?vue&type=script&lang=js"
export * from "./IconOrderBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports